// ============================================
// DATOS EDITABLES - Modifica aquí los datos del responsable
// ============================================
export const LEGAL_CONFIG = {
  responsable: 'Pablo Maggiani Aguilera',
  domicilio: 'Calle Río Nilo 408, Gaviotas, Mazatlán, Sinaloa, México',
  correoContacto: 'contacto@proyectoresidente.com',
  correoLegal: 'legal@proyectoresidente.com',
  correoPrivacidad: 'privacidad@proyectoresidente.com',
  correoSoporte: 'soporte@proyectoresidente.com',
  precio: '$1,500 MXN',
  periodoAcceso: '6 meses',
  ciudadJurisdiccion: 'Mazatlán, Sinaloa',
  fechaActualizacion: '27 de febrero de 2026',
};
